export const socialsData = {
    github: 'https://github.com/shamzaovais/',
    facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/syedhamzaovais/',
    instagram: 'https://www.instagram.com/',
    twitter: 'https://twitter.com/',
    reddit: 'https://www.reddit.com/user/datapawn/',
    blogger: 'https://www.blogger.com/profile/07849246269556305102',
    buymeacoffee: 'https://www.buymeacoffee.com/sydhamzaovg',
    stackOverflow: 'https://stackoverflow.com/users/20643359/hamza-ovais/',
    gitlab: 'https://gitlab.com/',
    youtube: 'https://youtube.com/',
    fiverr: 'https://www.fiverr.com/syedhamzazaidi',
    Upwork: 'https://www.upwork.com/freelancers/~01e284d2caa1b9a7c'
}  